import { Component, EventEmitter, OnDestroy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { BiometricService } from "../services/capacitor-biometric.class";
import { BiometryError } from "@aparajita/capacitor-biometric-auth";

@Component({
   template: ''
})
export abstract class CommonPin implements OnDestroy {
   public pinMode!: string
   public openSupportModal: EventEmitter<boolean> = new EventEmitter();

   correctBio?: boolean;

   get enabledBio(): boolean {
      return this.biometricService.biometry.isAvailable;
   }

   get wrongBio(): boolean {
      return this.enabledBio && this.correctBio === false;
   }
   get hideBio(): boolean {
      return this.biometricService.hideBio;
   }

   async checkBio() {
      this.correctBio = undefined;
      try {
         await this.biometricService.onAuthenticate();
         this.correctBio = true;
         this.modalCtrl.getTop().then((p:any)=>{
            if(p)p.canDismiss = true;
            return this.modalCtrl.dismiss(true, 'confirm');
          })
      } catch (error) {
         this.correctBio = false;
         console.log(error as BiometryError);
      }
   }
   constructor(
      public biometricService: BiometricService,
      public modalCtrl: ModalController,
   ) {}

   ngOnDestroy(): void {
   }
}